// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-component-parent {
    width: 100%
}
.tab-component-container {
    display: block;
    width: calc(80% + 60px);
    margin: 0 auto;
}

.tab-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    float: left;
    width: 100%;
    margin-top: -66px;
    position: relative;
}

.tab {
    display: flex;
    width: 100%;
    background-color: #fff;
    border-radius: 6px;
    z-index: 111;
    justify-content: space-around;
    padding: 0 52px;
}

.tabContainer {
    float: left;
    padding: 20px 0;
    text-align: center;
    display: block;

}

.tabLabel {
    outline: none;
    border: none;
    background-color: #fff;
    padding: 5px;
}

.tabContainer > button::-moz-focus-inner {
    outline: none;
}

.tabContainer> button:focus {
    outline:none;
}

.activeLabel {
    border-bottom: 3px solid #1e76ab;
    border-radius: 1px;
    color: #1e76ab;
    font-family: 'Rubik-Medium', 'Rubik-Regular';

}

.tab-dropdown {
    position: relative;
    border: none;
    outline: none;
    background: white;
    display: none;
}

.tab-dropdown .dropbtn {
    font-size: 16px;
    border: none;
    outline: none;
    padding: 14px 0px;
    background-color: #fff;
    font-family: inherit;
    margin: 0;
    display: none;
    min-width: 240px;
}

.tab-dropdown .dropbtn i {
    margin-left: 8px;
}

@media screen and (max-width: 768px) {
    .tab-wrapper{
        margin-top: -55px;
        position: absolute;
        top: 0;
    }
    .tab {
        width: 250px;
        display: block;
        border-radius: 4px;
        padding-left: 5px;
    }

    .tab-component-container {
        width: 100%;
        position: relative;
    }

    .tabContainer {
        display: none;
    }
    .tab-dropdown{
        display: block;
        width: 250px;
        border-radius: 4px;
    }
    .tab-dropdown .dropbtn {
        display: block;
    }
}

@media screen and (max-width: 650px) {
    .tab-component-container {
        width: 100%
    }
}

.button-wrapper {
    text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/Tabs/styles.css"],"names":[],"mappings":"AAAA;IACI;AACJ;AACA;IACI,cAAc;IACd,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,cAAc;IACd,4CAA4C;;AAEhD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI;QACI,iBAAiB;QACjB,kBAAkB;QAClB,MAAM;IACV;IACA;QACI,YAAY;QACZ,cAAc;QACd,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;IACA;QACI,cAAc;QACd,YAAY;QACZ,kBAAkB;IACtB;IACA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;IACI,kBAAkB;AACtB","sourcesContent":[".tab-component-parent {\n    width: 100%\n}\n.tab-component-container {\n    display: block;\n    width: calc(80% + 60px);\n    margin: 0 auto;\n}\n\n.tab-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    float: left;\n    width: 100%;\n    margin-top: -66px;\n    position: relative;\n}\n\n.tab {\n    display: flex;\n    width: 100%;\n    background-color: #fff;\n    border-radius: 6px;\n    z-index: 111;\n    justify-content: space-around;\n    padding: 0 52px;\n}\n\n.tabContainer {\n    float: left;\n    padding: 20px 0;\n    text-align: center;\n    display: block;\n\n}\n\n.tabLabel {\n    outline: none;\n    border: none;\n    background-color: #fff;\n    padding: 5px;\n}\n\n.tabContainer > button::-moz-focus-inner {\n    outline: none;\n}\n\n.tabContainer> button:focus {\n    outline:none;\n}\n\n.activeLabel {\n    border-bottom: 3px solid #1e76ab;\n    border-radius: 1px;\n    color: #1e76ab;\n    font-family: 'Rubik-Medium', 'Rubik-Regular';\n\n}\n\n.tab-dropdown {\n    position: relative;\n    border: none;\n    outline: none;\n    background: white;\n    display: none;\n}\n\n.tab-dropdown .dropbtn {\n    font-size: 16px;\n    border: none;\n    outline: none;\n    padding: 14px 0px;\n    background-color: #fff;\n    font-family: inherit;\n    margin: 0;\n    display: none;\n    min-width: 240px;\n}\n\n.tab-dropdown .dropbtn i {\n    margin-left: 8px;\n}\n\n@media screen and (max-width: 768px) {\n    .tab-wrapper{\n        margin-top: -55px;\n        position: absolute;\n        top: 0;\n    }\n    .tab {\n        width: 250px;\n        display: block;\n        border-radius: 4px;\n        padding-left: 5px;\n    }\n\n    .tab-component-container {\n        width: 100%;\n        position: relative;\n    }\n\n    .tabContainer {\n        display: none;\n    }\n    .tab-dropdown{\n        display: block;\n        width: 250px;\n        border-radius: 4px;\n    }\n    .tab-dropdown .dropbtn {\n        display: block;\n    }\n}\n\n@media screen and (max-width: 650px) {\n    .tab-component-container {\n        width: 100%\n    }\n}\n\n.button-wrapper {\n    text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
